import React from 'react';
import styles from '../Operations.module.css';

interface MGITComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGIT - Inventory $ Per Sqft (RO12)
 * KPI information component
 */
const MGIT: MGITComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Inventory per square foot measures the most recent rolling 12 months average inventory value divided by the store&apos;s retail square footage.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        There is a connection between having more and selling more, but it requires management of that inventory. Just buying more product and not successfully managing it (leaving it in backstock, forgetting about it, letting it get inaccurate) does not mean that deepening inventory will directly result in more sales. Therefore, there is a distinct path towards achieving and maintaining productive items within the Inventory per Square Feet goal.
      </div>

      <div className={styles.sectionContent}>
        Start with the basics:<br/>
        • Keeping Inventory Accurate<br/>
        • Monitoring and actioning obsolete inventory<br/>
        • Strategically set inventory exceptions
      </div>

      <div className={styles.sectionContent}>
        Ordering Opportunities once your inventory is controlled and accurate:<br/>
        • Discovery and Best Brand SKUs<br/>
        • Mango Report® Assortment Opportunity<br/>
        • Inventory Boost Ordering
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        $80 per square foot OR &gt;$5 YoY growth or<br/><br/>
        $70 per square foot for stores &gt;12,000 Square Feet
      </div>

      <div className={styles.sectionTitle}>
       Learn More
      </div>

      <div className={styles.sectionContent}>
        1. Validate the reported square footage of your business – work with your District Manager for corrections<br/>
        2. Achieve and maintain an Inventory Record Accuracy measurement of at least 80% (ACENET &gt; AWOR &gt; Achieving Inventory Accuracy)<br/>
        3. Maintain a level of 4.5% or less Obsolete inventory (ACENET &gt; AWOR &gt; Obsolete Inventory)<br/>
        4. Achieve inventory exception settings at their RAD stated goals (EOQ, Minimum Order Points)<br/>
        5. Finalize Planogram Change Management monthly to prevent Discovery acceptance erosion<br/>
        6. Increment inventory via the Mango Assortment Opportunity report monthly (<a href="https://hc.mangoreport.com/hc/en-us" target="_blank" rel="noopener noreferrer" className={styles.link}>www.mangoreport.com</a>)<br/>
        7. Use the Inventory Boost Tool to strategically boost inventory
      </div>
    </div>
  );
};

MGIT.title = 'Inventory per Square Foot';
MGIT.actionTitle = 'Inventory Boost Tool';
MGIT.actionHyperlink = 'dynamicURL:WFC:current';
export default MGIT;

